import { useAuth } from '@/auth/hooks/useAuth';

import type { BillingSummary } from '../api/FetchBillingList';

export const useIsLockedByOtherUser = (billing: BillingSummary) => {
  const { user } = useAuth();

  return (
    !!billing.inProgressForUser &&
    !!user?.localAccountId &&
    billing.inProgressForUser !== user.localAccountId
  );
};
